<template>
  <div class="all clearfix" >
    <div class="trans">
      <div class="grid pb30">
        <div class="search-warp w737">
          <!-- <button class="search-btn fr" @click="KeyUpEsc">查询</button>  -->
          <div class="hidden" >
            <input type="text" v-model="keywords" @keyup.enter="KeyUpEsc" placeholder="输入关键词" class="input-text ac" @focus="keyFocus" @input="keyInput" @keyup.down ="keyDown"  @keyup.up ="keyUp"/>
          </div>
          <ul class="keyli" v-show="isShowKeyList" >
            <li class="cp" :class="{'cur':curIndex == index }" v-for="(item,index) in keyList" :key="index" @click="addkeyInput(item,index)" >
              <span>{{item.keywords}}</span>
              <span class="fr">{{item.sum}}</span>
            </li>
          </ul>
        </div>
        <div class="warp mt5 clearfix">
          <div class="warp-body">
            <div class="artiWrap h680 hidden">
              <d3chart id="d3Svg" width="100%" height="680" ref="d3" :ds="dsCharts" :updateDs="updateDsCharts" @entityFatherMethod="getEntityChild"></d3chart>
              <div class="no-data mt0 pt40" v-if="nodata.knowEntity"><img src="static/images/no_data.png" class="img"/><span class="text crff">啥也没有找到，换个词试试吧~</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import d3chart from '../components/d3Chart.vue'
import pathChart from '../components/pathChart.vue';
export default {
  components: {d3chart,pathChart},
  data() {
    return {
      keywords:'军工', //搜索关键词
      isShowKeyList:false,
      default:1,
      curIndex:-1,
      keyList:[],
      dsCharts:[],
      updateDsCharts:[],
      showType:1,
      pathData:[],
      nodata:{
        knowEntity:false,
      },
      apiSecret : this.$route.query.api_secret?this.$route.query.api_secret:"",
    }
  },
  mounted() {
    let that = this;
    that.hotowrdAjax();
    that.getEntity();
    document.addEventListener('click',function(e){
      if(e.target.className!='input-text ac'){
        that.isShowKeyList=false;
      }
    })
  },
  methods: {
    //搜索知识图谱
    KeyUpEsc(){
      let that = this;
      that.dsCharts = [];
      that.isShowKeyList = false
      that.nodata.knowEntity = false;
      that.getEntity();
    },
    hotowrdAjax(){
      let that = this;
      that.$api.get('knowledge/index/hot-words',{api_secret:that.apiSecret}, r => {
        that.$parent.returnCode(r,function(){
          that.keyList = r.data
        })
      })
    },
    keyDown(){
      let that = this;
      let len = that.keyList.length-1;
      that.curIndex++;
      if(that.curIndex >len){
        that.curIndex = -1;
        that.keywords = ''
      }else{
        that.keywords = that.keyList[that.curIndex].keywords;
      }
    },
    keyUp(){
      let that = this;
      let len = that.keyList.length-1;
      that.curIndex--;
      if(that.curIndex == -2){
        that.curIndex = len;
        that.keywords = that.keyList[that.curIndex].keywords;
      }else if(that.curIndex == -1){
        that.keywords = ''
      }
    },
    //下拉点击
    keyFocus(){
      let that = this;
      if(that.keywords==''){
        that.isShowKeyList = true
      }
    },
    keyInput(){
      let that = this;
      that.isShowKeyList = (that.keywords == '') ? true : false
    },
    addkeyInput(item,index){
      let that = this;
      that.keywords = item.keywords;
      that.curIndex = index;
      that.isShowKeyList = false
      that.getEntity();
    },
    getEntity(item){
      let that = this;
      that.showType = 1;
      if(item == undefined){
        item = that.keywords;
      }
      let datas = {
        entity:item,
        default:that.default,
        api_secret:that.apiSecret
      };
      that.$api.get('knowledge/index/name',datas, r => {
        that.$parent.returnCode(r,function(){
          let data = r.data;
          if(data.length<=0){
            if(that.dsCharts.length<=0){
              that.nodata.knowEntity = true;
            }
            return;
          }
          let nodeJson = {
            nodes:[],
            links:[],
          }
          if(data[0][1]!=item){
            nodeJson.nodes.push({name:item})
          }

          if(data.length>0){
            data.forEach((ele,i) => {
              if(ele[1] == '') return
              let name = ele[1];
              if(i>0 && ele[1] == data[i-1][1] ){
                name = ele[1]+"("+ele[0] + ")"
                //return
              }
              let tmp = {};
              let tmp1 = {};
              tmp.name = name;
              tmp.id = ele[2];
              nodeJson.nodes.push(tmp)
              tmp1.source = item;
              tmp1.target = name;
              tmp1.relation = ele[0];
              nodeJson.links.push(tmp1)
            });
          }
          that.dsCharts = nodeJson;
          that.default = '';
          //console.log(that.dsCharts);
        })
      })
    },
    getEntityChild(item,id){
      let that = this;
      let datas = {
        node_id:id,
      };
      that.$api.get('knowledge/index/node-id',datas, r => {
        that.$parent.returnCode(r,function(){
          let data = r.data;
          let nodeJson = {
            nodes:[],
            links:[],
          }
          // if(data[0][1]!=item){
          //     nodeJson.nodes.push({name:item})
          // }
          if(data.length>0){
            data.forEach((ele,i) => {
              if(ele[1] == '') return
              let name = ele[1];
              if(i>0 && ele[1] == data[i-1][1] ){
                name = ele[1]+"("+ele[0] + ")"
                //return
              }
              let tmp = {};
              let tmp1 = {};
              tmp.name = name;
              tmp.id = ele[2];
              nodeJson.nodes.push(tmp)
              tmp1.source = item;
              tmp1.target = name;
              tmp1.relation = ele[0];
              nodeJson.links.push(tmp1)
            });
          }
          that.updateDsCharts = nodeJson;
        })
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/page/knowledge.vue